import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Service()
export class CardStatusGuard {
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route.params['cardId']) {
      return this.router.createUrlTree(['/check-validity'], {
        queryParams: {
          cn: route.params['cardId']
        },
        queryParamsHandling: 'merge'
      });
    }
    return this.router.createUrlTree(['/check-validity']);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    _: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!childRoute.params['cardId']) {
      return this.router.createUrlTree(['/check-validity'], {
        queryParams: {
          cn: childRoute.params['cardId']
        },
        queryParamsHandling: 'merge'
      });
    }
    return this.router.createUrlTree(['/check-validity']);
  }
}
